import { useEffect, useState } from "react";

interface Props {
  number: string;
  description: string;
  status: string;
  category: string;
  timespend: string;
  currentplantime: string;
  remainingtime: string;
  operator: string;
  plannedfinaldate: string;
  plannedstartdate: string;
  startdate: string;
  processingStatus: string;
}

const Activity = ({
  number,
  description,
  status,
  category,
  timespend,
  currentplantime,
  remainingtime,
  operator,
  plannedfinaldate,
  plannedstartdate,
  startdate,
  processingStatus,
}: Props) => {
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    const checkIfExpired = () => {
      const today = new Date();
      const [day, month, year] = plannedfinaldate.split("-").map(Number);
      const finalDate = new Date(year, month - 1, day);

      if (today > finalDate) {
        setIsExpired(true);
      }
    };

    checkIfExpired();
  }, [plannedfinaldate]);

  return (
    <div
      className={`flex justify-center text-black text-[1vh] h-[4vh] w-[110vw] border-b border-gray-300 ${
        processingStatus === "finished"
          ? "flex text-black text-[1vh] h-[4vh] w-[110vw] bg-[#b7f3b7] rounded-2xl"
          : isExpired
          ? "flex text-[#cf2020] text-[1vh] h-[4vh] w-[110vw] border-b border-gray-300"
          : ""
      }`}
    >
      <p className="w-[10vh] text-center mt-auto mb-auto">{number}</p>
      <p className="w-[10vw] text-left mb-auto mt-auto whitespace-nowrap overflow-hidden text-ellipsis">
        {description}
      </p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{status}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{category}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{timespend}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{currentplantime}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{remainingtime}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{operator}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{plannedfinaldate}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{plannedstartdate}</p>
      <p className="w-[10vh] text-center mt-auto mb-auto">{startdate}</p>
    </div>
  );
};

export default Activity;
